import { authFetch } from "utils";

export const getDealChannels = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/channels`, {
    method: "GET",
  });

export const deleteChannel = (dealID, channelID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/channels/${channelID}`, {
    method: "DELETE",
  });

export const saveChannel = (dealID, channel) => {
  if (channel.id) {
    return authFetch(`${apiUrl}${version}/deals/${dealID}/channels/${channel.id}`, {
      method: "PATCH",
      json: channel,
    });
  }

  return authFetch(`${apiUrl}${version}/deals/${dealID}/channels`, {
    method: "POST",
    json: channel,
  });
};
